import { FreeTalkView } from '../features/freeTalk/ui/freeTalkView.tsx'

export function FreeTalkPage() {
  return <FreeTalkView />
}
